import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthQuery } from '../auth-http-client';
import { entityWithNameSchema } from '../types';

export const createGetCashiersQuery = () =>
	createAuthQuery({
		params: declareParams<number>(),
		request: {
			method: 'GET',
			url: (id) => `/account/cashiers/${id}`,
		},
		response: {
			contract: zodContract(entityWithNameSchema.array()),
		},
	});

export const getCashiersQuery = createGetCashiersQuery();
